import { render } from "./ElectricalMeasurements.vue?vue&type=template&id=2c20828c"
import script from "./ElectricalMeasurements.vue?vue&type=script&lang=js"
export * from "./ElectricalMeasurements.vue?vue&type=script&lang=js"
script.render = render

export default script